import React, { Component } from "react";
import axios from "axios";
import {
  API_INFORMES,
  API_INFORMES_PDF,
  TIPO_INFORME_EVAL_PLAN,
  pdfEvalPlanScript,
  emptyDatosEvalPlan,
  estadoFirmaEspecialista,
  MSG_FIRMA_PDF_REQUERIDA,
  solicitarAyudaInformePlan,
} from "./api";
import FirmaEspecialistaInforme from "./FirmaEspecialistaInforme";
import AyudaInformePlanModal from "./AyudaInformePlanModal";
import { mergeAyudaEnDatosPlan, contextoPacienteParaAyuda } from "./ayudaInformePlan";
import {
  TIPO_CAMPO,
  CAMPOS_MOTIVO,
  CAMPOS_TEXTO_LARGO,
  CAMPOS_ABVD,
  CAMPOS_AIVD_BASE,
  CAMPOS_AIVD_ESCOLAR,
  CAMPOS_MOTOR,
  CAMPOS_COGNITIVO,
  CAMPOS_FIRMAS,
  filtrarCamposGenerales,
} from "./camposEvalPlan";

class InformeEvaluacionPlan extends Component {
  constructor(props) {
    super(props);
    this.firmaRef = React.createRef();
    this.state = {
      datos: emptyDatosEvalPlan(),
      formato: "INFANTIL",
      guardando: false,
      tieneFirmaEsp: false,
      reportesModalAbierto: false,
      reportesCargando: false,
      reportesError: "",
      reportesCita: [],
      reportesDuplicados: 0,
      ayudaAbierta: false,
      ayudaCargando: false,
      ayudaError: "",
      ayudaSugerencia: null,
      ayudaAviso: "",
      ayudaMeta: null,
    };
  }

  componentDidMount() {
    this.cargarDatos();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.idInforme !== this.props.idInforme ||
      prevProps.idasociarE !== this.props.idasociarE ||
      prevProps.initialDatos !== this.props.initialDatos
    ) {
      this.cargarDatos();
    }
  }

  cargarDatos = () => {
    if (this.props.initialDatos && !this.props.idInforme) {
      const datos = {
        ...emptyDatosEvalPlan(),
        ...this.props.initialDatos,
        datosGenerales: {
          ...emptyDatosEvalPlan().datosGenerales,
          ...(this.props.initialDatos.datosGenerales || {}),
        },
      };
      this.setState({
        datos,
        formato: this.props.initialDatos.formato || this.props.formato || "INFANTIL",
      });
      return;
    }
    const { idInforme, cedulaPaciente, idasociarE } = this.props;
    if (idInforme > 0) {
      const data = new FormData();
      data.append("boton", "obtener");
      data.append("idInforme", idInforme);
      data.append("cedulaEspecialista", this.props.cedulaEspecialista || "");
      axios.post(API_INFORMES, data).then((res) => {
        if (res.data.variable1) {
          const row = res.data.variable2;
          const datos = res.data.variable3 || emptyDatosEvalPlan();
          this.setState({
            datos,
            formato: row.formato || "INFANTIL",
          });
        }
      });
      return;
    }
    const data = new FormData();
    data.append("boton", "datosPacienteBase");
    data.append("cedulaPaciente", cedulaPaciente);
    data.append("idasociarE", idasociarE);
    axios.post(API_INFORMES, data).then((res) => {
      if (res.data.variable1) {
        const base = res.data.variable2;
        this.setState({
          datos: {
            ...emptyDatosEvalPlan(),
            datosGenerales: {
              ...emptyDatosEvalPlan().datosGenerales,
              ...base,
            },
          },
          formato: base.formato || "INFANTIL",
        });
      }
    });
  };

  setDg = (field, value) => {
    this.setState({
      datos: {
        ...this.state.datos,
        datosGenerales: {
          ...this.state.datos.datosGenerales,
          [field]: value,
        },
      },
    });
  };

  setField = (field, value) => {
    this.setState({
      datos: { ...this.state.datos, [field]: value },
    });
  };

  setNested = (group, field, value) => {
    this.setState({
      datos: {
        ...this.state.datos,
        [group]: { ...this.state.datos[group], [field]: value },
      },
    });
  };

  guardar = () => {
    const {
      cedulaPaciente,
      cedulaEspecialista,
      tipoEvaluacion,
      idasociarE,
      idasociarEGrupo,
      sede,
      idInforme,
      onGuardado,
    } = this.props;
    const { datos, formato } = this.state;
    const dg = datos.datosGenerales;
    this.setState({ guardando: true });
    const data = new FormData();
    data.append("boton", "guardar");
    data.append("tipoInforme", TIPO_INFORME_EVAL_PLAN);
    data.append("ramaEspecialidad", this.props.ramaEspecialidad || "OCUPACIONAL");
    data.append("idInforme", idInforme || 0);
    data.append("cedulaPaciente", cedulaPaciente);
    data.append("cedulaEspecialista", cedulaEspecialista);
    data.append("tipoEvaluacion", tipoEvaluacion);
    data.append("idasociarE", idasociarE);
    const idsGrupoPlan =
      Array.isArray(idasociarEGrupo) && idasociarEGrupo.length > 0
        ? idasociarEGrupo
        : [idasociarE];
    data.append("idasociarEGrupo", idsGrupoPlan.join(","));
    data.append("formato", formato);
    data.append("fechaInforme", dg.fechaInforme);
    data.append("fechaInicioTerapia", dg.fechaInicioTerapia);
    data.append("sede", sede || "");
    data.append("usuario", cedulaEspecialista);
    data.append("datosJson", JSON.stringify(datos));
    axios.post(API_INFORMES, data).then((res) => {
      this.setState({ guardando: false });
      if (res.data.variable1) {
        alert("Fue guardado el Informe de Evaluacion y Plan");
        if (onGuardado) onGuardado(res.data.variable2);
      } else {
        alert(res.data.variable2 || res.data.variable3 || "Error al guardar.");
      }
    });
  };

  imprimir = async () => {
    const { idInforme, cedulaEspecialista } = this.props;
    const { formato, tieneFirmaEsp } = this.state;
    if (!idInforme) {
      alert("Guarde el informe antes de imprimir.");
      return;
    }
    if (!cedulaEspecialista) {
      alert("No se identifico al especialista en sesion.");
      return;
    }
    let tieneFirma = tieneFirmaEsp;
    if (!tieneFirma) {
      try {
        const est = await estadoFirmaEspecialista(cedulaEspecialista);
        tieneFirma = est.tiene;
        if (tieneFirma) {
          this.setState({ tieneFirmaEsp: true });
        }
      } catch (e) {
        tieneFirma = false;
      }
    }
    if (!tieneFirma) {
      alert(MSG_FIRMA_PDF_REQUERIDA);
      if (this.firmaRef.current && this.firmaRef.current.abrirSelector) {
        this.firmaRef.current.abrirSelector();
      }
      return;
    }
    const script = pdfEvalPlanScript(formato, this.props.ramaEspecialidad || "OCUPACIONAL");
    if (!script) {
      alert("No hay plantilla PDF para esta especialidad.");
      return;
    }
    const urlPdf =
      API_INFORMES_PDF +
      script +
      "?idInforme=" +
      encodeURIComponent(String(idInforme));
    const data = new FormData();
    data.append("idInforme", idInforme);
    axios({
      method: "post",
      url: API_INFORMES_PDF + script,
      responseType: "arraybuffer",
      data,
    })
      .then((response) => {
        const buf = response.data;
        if (!buf || buf.byteLength < 100) {
          window.open(urlPdf, "_blank");
          return;
        }
        const u8 = new Uint8Array(buf);
        const esPdf =
          u8.length >= 4 &&
          u8[0] === 0x25 &&
          u8[1] === 0x50 &&
          u8[2] === 0x44 &&
          u8[3] === 0x46;
        if (!esPdf) {
          try {
            const txt = new TextDecoder("utf-8").decode(buf);
            if (txt && txt.length < 800) {
              alert(txt.trim() || "El servidor no devolvio un PDF valido.");
              return;
            }
          } catch (e) {
            /* ignorar */
          }
          window.open(urlPdf, "_blank");
          return;
        }
        const blob = new Blob([buf], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob));
      })
      .catch(() => {
        window.open(urlPdf, "_blank");
      });
  };

  solicitarAyudaInforme = () => {
    if (Number(this.props.idInforme) > 0) {
      return;
    }
    const { idasociarE, idasociarEGrupo, cedulaPaciente, nombrePaciente } = this.props;
    const { datos, formato } = this.state;
    if (!idasociarE) {
      alert("No se identifico el estudio del paciente.");
      return;
    }
    this.setState({
      ayudaAbierta: true,
      ayudaCargando: true,
      ayudaError: "",
      ayudaSugerencia: null,
      ayudaAviso: "",
      ayudaMeta: null,
    });
    const contexto = contextoPacienteParaAyuda(
      datos,
      nombrePaciente || cedulaPaciente,
      formato
    );
    solicitarAyudaInformePlan({
      idasociarE,
      idasociarEGrupo,
      formato,
      contextoPaciente: contexto,
    })
      .then((res) => {
        if (res && res.variable1 && res.variable2) {
          this.setState({
            ayudaCargando: false,
            ayudaSugerencia: res.variable2,
            ayudaAviso: res.variable3 || "",
            ayudaMeta: {
              reportes: res.variable4 || 0,
              duplicados: res.variable5 || 0,
            },
          });
        } else {
          this.setState({
            ayudaCargando: false,
            ayudaError:
              (res && res.variable2) ||
              "No se pudo generar el borrador. Verifique la API de Gemini en el servidor.",
          });
        }
      })
      .catch(() => {
        this.setState({
          ayudaCargando: false,
          ayudaError: "Error de conexion al solicitar Ayuda Informe.",
        });
      });
  };

  cerrarAyudaInforme = () => {
    this.setState({
      ayudaAbierta: false,
      ayudaCargando: false,
      ayudaError: "",
    });
  };

  aplicarAyudaInforme = () => {
    const { ayudaSugerencia, datos, formato } = this.state;
    if (!ayudaSugerencia) return;
    const escolar = formato === "ESCOLAR";
    const merged = mergeAyudaEnDatosPlan(datos, ayudaSugerencia, escolar);
    this.setState({
      datos: merged,
      ayudaAbierta: false,
      ayudaCargando: false,
      msg:
        "Se aplico el borrador de IA al formulario. Revise cada campo y guarde cuando este conforme.",
    });
  };

  abrirReportes = () => {
    const { idasociarE, idasociarEGrupo } = this.props;
    const ids =
      Array.isArray(idasociarEGrupo) && idasociarEGrupo.length > 0
        ? idasociarEGrupo.map((id) => String(id))
        : idasociarE
          ? [String(idasociarE)]
          : [];
    const idPrincipal = idasociarE || (ids.length > 0 ? ids[0] : "");
    if (!idPrincipal) {
      this.setState({ reportesError: "No se identificó el estudio (idasociarE)." });
      return;
    }
    const data = new FormData();
    data.append("boton", "listarReportesCita");
    data.append("idasociarE", idPrincipal);
    if (ids.length > 1) {
      data.append("idasociarEGrupo", ids.join(","));
    }
    this.setState({
      reportesModalAbierto: true,
      reportesCargando: true,
      reportesError: "",
      reportesCita: [],
      reportesDuplicados: 0,
    });
    axios
      .post(API_INFORMES, data)
      .then((res) => {
        if (res.data && res.data.variable1) {
          this.setState({
            reportesCargando: false,
            reportesCita: Array.isArray(res.data.variable2) ? res.data.variable2 : [],
            reportesDuplicados: Number(res.data.variable3 || 0),
          });
          return;
        }
        this.setState({
          reportesCargando: false,
          reportesError: (res.data && res.data.variable2) || "No se pudo cargar los reportes.",
        });
      })
      .catch((err) => {
        this.setState({
          reportesCargando: false,
          reportesError: err.message || "No se pudo cargar los reportes.",
        });
      });
  };

  cerrarReportes = () => {
    this.setState({ reportesModalAbierto: false });
  };

  /** Control según tipo: una línea (input) o varias (textarea) */
  renderControl = (config, value, onChange) => {
    const tipo = config.tipo || TIPO_CAMPO.LINEA;
    if (tipo === TIPO_CAMPO.FECHA) {
      return (
        <input
          type="date"
          className="ic-input ic-input-line"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }
    if (tipo === TIPO_CAMPO.MULTILINEA) {
      return (
        <textarea
          className="ic-textarea"
          rows={config.rows || 4}
          maxLength={config.maxLength || 2000}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }
    return (
      <input
        type="text"
        className="ic-input ic-input-line"
        maxLength={config.maxLength || 120}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        title={value || ""}
      />
    );
  };

  renderCampoDg = (config) => {
    const dg = this.state.datos.datosGenerales;
    const val = config.key === "edadTexto" ? dg.edadTexto || dg.edad || "" : dg[config.key];
    return (
      <div className="ic-field" key={config.key}>
        <label className="ic-label">{config.label}</label>
        {this.renderControl(config, val, (v) => this.setDg(config.key, v))}
      </div>
    );
  };

  renderCampoRaiz = (config) => (
    <div className="ic-field" key={config.key}>
      <label className="ic-label">{config.label}</label>
      {this.renderControl(config, this.state.datos[config.key], (v) =>
        this.setField(config.key, v)
      )}
    </div>
  );

  renderCampoGrupo = (grupo, config) => (
    <div className="ic-field" key={config.key}>
      <label className="ic-label">{config.label}</label>
      {this.renderControl(config, this.state.datos[grupo][config.key], (v) =>
        this.setNested(grupo, config.key, v)
      )}
    </div>
  );

  renderSeccion = (titulo, children) => (
    <div className="ic-formSection">
      <h4>{titulo}</h4>
      {children}
    </div>
  );

  render() {
    const {
      datos,
      formato,
      guardando,
      reportesModalAbierto,
      reportesCargando,
      reportesError,
      reportesCita,
      reportesDuplicados,
      ayudaAbierta,
      ayudaCargando,
      ayudaError,
      ayudaSugerencia,
      ayudaAviso,
      ayudaMeta,
    } =
      this.state;
    const escolar = formato === "ESCOLAR";
    const camposGen = filtrarCamposGenerales(escolar);
    const aivdCampos = escolar
      ? [...CAMPOS_AIVD_BASE, ...CAMPOS_AIVD_ESCOLAR]
      : CAMPOS_AIVD_BASE;
    const informeYaGuardado = Number(this.props.idInforme) > 0;

    return (
      <div className="ic-panel ic-form-document">
        <p>
          Paciente:{" "}
          <strong>{this.props.nombrePaciente || this.props.cedulaPaciente}</strong>
        </p>
        <p className="ic-formato-badge">
          <strong>Formato:</strong>{" "}
          {escolar ? "Uso escolar (> 5 años)" : "Infantil (1 a 5 años)"}
        </p>
        <div className="ic-actions ic-actions-sticky">
          <button type="button" className="boton" onClick={this.props.onVolver}>
            Volver
          </button>
        </div>

        <AyudaInformePlanModal
          abierto={ayudaAbierta}
          cargando={ayudaCargando}
          error={ayudaError}
          sugerencia={ayudaSugerencia}
          aviso={ayudaAviso}
          meta={ayudaMeta}
          formato={formato}
          onCerrar={this.cerrarAyudaInforme}
          onAplicar={this.aplicarAyudaInforme}
          onRegenerar={this.solicitarAyudaInforme}
        />

        {this.renderSeccion(
          "Datos generales",
          <div className="ic-grid-datos">
            {camposGen.map((c) => this.renderCampoDg(c))}
          </div>
        )}

        {this.renderSeccion(
          "Motivo de la consulta",
          <>
            <p className="ic-plantilla-texto">
              El menor <span className="ic-plantilla-hueco">(nombre)</span> en compañía de{" "}
              <span className="ic-plantilla-hueco">(acompañante)</span>, referido por{" "}
              <span className="ic-plantilla-hueco">(referido)</span>.
            </p>
            <div className="ic-grid-datos ic-grid-3">
              {CAMPOS_MOTIVO.map((c) => this.renderCampoRaiz(c))}
            </div>
          </>
        )}

        {CAMPOS_TEXTO_LARGO.slice(0, 3).map((c) =>
          this.renderSeccion(c.label, this.renderCampoRaiz({ ...c, tipo: TIPO_CAMPO.MULTILINEA, rows: c.rows }))
        )}

        {this.renderSeccion(
          "A. Actividades básicas de la vida diaria",
          <div className="ic-grid-campos">{CAMPOS_ABVD.map((c) => this.renderCampoGrupo("abvd", c))}</div>
        )}

        {this.renderSeccion(
          "B. Actividades instrumentales de la vida diaria",
          <div className="ic-grid-campos">{aivdCampos.map((c) => this.renderCampoGrupo("aivd", c))}</div>
        )}

        {this.renderSeccion(
          "C. Desarrollo motor",
          <div className="ic-grid-campos">{CAMPOS_MOTOR.map((c) => this.renderCampoGrupo("motor", c))}</div>
        )}

        {this.renderSeccion(
          "D. Habilidades de procesamiento (integración cognitiva / perceptiva)",
          <div className="ic-grid-campos">
            {CAMPOS_COGNITIVO.map((c) => this.renderCampoGrupo("cognitivo", c))}
          </div>
        )}

        {CAMPOS_TEXTO_LARGO.slice(3).map((c) =>
          this.renderSeccion(c.label, this.renderCampoRaiz({ ...c, tipo: TIPO_CAMPO.MULTILINEA, rows: c.rows }))
        )}

        {this.renderSeccion(
          "Firmas",
          <div className="ic-grid-2">{CAMPOS_FIRMAS.map((c) => this.renderCampoRaiz(c))}</div>
        )}

        <FirmaEspecialistaInforme
          ref={this.firmaRef}
          cedulaEspecialista={this.props.cedulaEspecialista}
          onCambio={(tiene) => this.setState({ tieneFirmaEsp: tiene })}
        />

        <div className="ic-actions">
          <button type="button" className="boton" onClick={this.guardar} disabled={guardando}>
            {guardando ? "Guardando..." : "Guardar"}
          </button>
          <button type="button" className="boton" onClick={this.imprimir}>
            Imprimir PDF
          </button>
          {this.props.idInforme > 0 && this.props.onEliminar && (
            <button
              type="button"
              className="boton ic-btn-danger"
              onClick={() => this.props.onEliminar(this.props.idInforme)}
            >
              Eliminar informe
            </button>
          )}
          <button type="button" className="boton" onClick={this.abrirReportes}>
            Reportes Diarios
          </button>
          <button
            type="button"
            className="boton ic-btn-ayuda"
            onClick={this.solicitarAyudaInforme}
            disabled={ayudaCargando || informeYaGuardado}
            title={
              informeYaGuardado
                ? "Ayuda Informe solo esta disponible al crear el informe por primera vez"
                : ""
            }
          >
            {ayudaCargando ? "Generando ayuda..." : "Ayuda Informe"}
          </button>
          <button type="button" className="boton" onClick={this.props.onVolver}>
            Volver
          </button>
        </div>

        {reportesModalAbierto && (
          <div className="ic-modalOverlay" onClick={this.cerrarReportes}>
            <div className="ic-modalCard" onClick={(e) => e.stopPropagation()}>
              <div className="ic-modalHeader">
                <h4>Reportes de la cita</h4>
                <button type="button" className="boton" onClick={this.cerrarReportes}>
                  Cerrar
                </button>
              </div>
              {reportesCargando && <p>Cargando reportes...</p>}
              {!reportesCargando && reportesError && <div className="ic-msg">{reportesError}</div>}
              {!reportesCargando && !reportesError && reportesCita.length === 0 && (
                <p>No hay reportes registrados para este estudio.</p>
              )}
              {!reportesCargando && reportesDuplicados > 0 && (
                <p className="ic-hint">
                  Se ocultaron {reportesDuplicados} reporte(s) duplicado(s) en esta vista.
                </p>
              )}
              {!reportesCargando && reportesCita.length > 0 && (
                <div className="ic-modalList">
                  {reportesCita.map((r, idx) => (
                    <div key={`${r.idmensaje}-${idx}`} className="ic-modalItem">
                      <div>
                        <strong>Fecha cita:</strong> {r.fechaCita || "-"}{" "}
                        <span className="ic-hint">| Registro: {r.fechaMensaje || "-"}</span>
                      </div>
                      <div>
                        <strong>Mensaje:</strong> {r.mensaje || "(sin texto)"}
                      </div>
                      {r.ruta ? (
                        <div>
                          <strong>Adjunto:</strong> {r.ruta}
                        </div>
                      ) : null}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default InformeEvaluacionPlan;
